import {Interval, IRange, Matm} from '../../classes/Matm';
import {ReplaySubject} from 'rxjs';

declare let THREE: any;

export class Sky extends (THREE.Object3D as { new(): any; }) {

  public readonly onSunPositionChange: ReplaySubject<any>;
  private sky;

  private readonly distance = 9000;

  private inclinationRange: IRange;

  private azimuthRange: IRange;

  private sunSphere;

  private effectController = {
    turbidity: 7.1,
    rayleigh: 1.423,
    mieCoefficient: 0.005,
    mieDirectionalG: 0.984,
    luminance: 1,
    inclination: 0,
    azimuth: 0,
    sun: false
  };

  constructor(
    inclinationRange: IRange,
    azimuthRange: IRange
  ) {
    super();

    this.inclinationRange = inclinationRange;
    this.azimuthRange = azimuthRange;
    this.effectController.inclination = inclinationRange.min;
    this.effectController.azimuth = azimuthRange.min;
    this.onSunPositionChange = new ReplaySubject<any>();

    const sky = new THREE.Sky();
    sky.scale.setScalar(10000);
    this.add(sky);
    this.sky = sky;

    const sunSphere = new THREE.Mesh(
      new THREE.SphereBufferGeometry(20000, 16, 8),
      new THREE.MeshBasicMaterial({color: 0xffffff})
    );
    sunSphere.position.y = -700000;
    sunSphere.visible = false;
    this.add(sunSphere);
    this.sunSphere = sunSphere;

    this.updateSunPosition(this.effectController);

    this.name = 'sky';
  }

  private updateSunPosition(effectController) {
    const sunSphere = this.sunSphere;
    const distance = this.distance;
    const uniforms = this.sky.material.uniforms;
    const theta = Math.PI * (effectController.inclination - 0.5);
    const phi = 2 * Math.PI * (effectController.azimuth - 0.5);
    sunSphere.position.x = distance * Math.cos(phi);
    sunSphere.position.y = distance * Math.sin(phi) * Math.sin(theta);
    sunSphere.position.z = distance * Math.sin(phi) * Math.cos(theta);
    sunSphere.visible = effectController.sun;
    uniforms['sunPosition'].value.copy(sunSphere.position);
    this.onSunPositionChange.next(sunSphere.position);
  }

  interpolate(input: Interval) {
    const effectController = this.effectController;
    effectController.inclination = Matm.mapRange(input, this.inclinationRange);
    effectController.azimuth = Matm.mapRange(input, this.azimuthRange);
    this.updateSunPosition(effectController);
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/Sky.ts